






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {OcorrenciaTracking} from '@/model/resource/OcorrenciaTracking'
import {InputOcorrenciaTrackingSchema} from '@/schema/resource/OcorrenciaTracking/InputOcorrenciaTrackingSchema'

@Component
export default class PersistOcorrenciaTrackingView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputOcorrenciaTrackingSchema()
  ocorrenciaTracking = new OcorrenciaTracking()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionCarga.listCarga()
    this.schema.collectionTipoOcorrencia.listTipoOcorrencia()
    this.schema.collectionResponsavel.listResponsavel()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.ocorrenciaTracking.getOcorrenciaTracking(id)
    }

    $.await.done('getOcorrenciaTracking')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.ocorrenciaTracking.persistOcorrenciaTracking()
    await Helper.successAndPush(
      'system.success.persist',
      '/ocorrencia-tracking/list'
    )
  }
}
